import React, { useMemo } from "react";
import { UserStatsFicha } from "../types";
import { RankingItem } from "./RankingItem";
import { EmptyState } from "./EmptyState";
import { useRankingFichaTvAutoScroll } from "../hooks/useRankingFichaTvAutoScroll";

interface RankingListProps {
  usuarios: UserStatsFicha[];
  maxItems?: number;
}

const CLASSE_LISTA = [
  "relative min-h-0 flex-1 overflow-y-auto overscroll-y-contain",
  "space-y-3 sm:space-y-4",
  "[scrollbar-width:none] [&::-webkit-scrollbar]:[display:none]",
].join(" ");

export const RankingList: React.FC<RankingListProps> = ({
  usuarios,
  maxItems = 12,
}) => {
  const visiveis = usuarios.slice(0, maxItems);
  const listaFingerprint = useMemo(
    () => visiveis.map((u) => u.usuarioId).join(","),
    [visiveis]
  );
  const { listaRef, rolagemAutomatica } = useRankingFichaTvAutoScroll(
    visiveis.length,
    listaFingerprint
  );

  if (usuarios.length === 0) {
    return <EmptyState />;
  }

  return (
    <div
      ref={listaRef}
      role="region"
      aria-label={
        rolagemAutomatica
          ? "Ranking da ficha diária, lista com rolagem automática em ciclo"
          : "Ranking da ficha diária"
      }
      className={CLASSE_LISTA}
    >
      {visiveis.map((usuario, index) => (
        <RankingItem
          key={usuario.usuarioId}
          usuario={usuario}
          index={index}
        />
      ))}
    </div>
  );
};
